import React from 'react'
import './faqs.css';

function FAQs() {
  return (
    <div className='faq-container'>
<section className="faq-section">
  <h3>Frequently Asked Questions</h3>

  <div className="faq-item">
    <h4>What is the Eye Care Digital Library?</h4>
    <p>The Eye Care Digital Library is an online platform offering a wide range of eye care-related resources, including clinical materials, e-books, theses, journal articles, and research papers.</p>
  </div>

  <div className="faq-item">
    <h4>What types of resources are available?</h4>
    <p>We provide access to clinical resources, e-books, research theses, journal articles, and other academic materials related to optometry and vision science.</p>
  </div>

  <div className="faq-item">
    <h4>Can I contribute my own research or publications?</h4>
    <p>Yes! Users can contribute e-books, research journal articles, and other relevant resources. Your contributions help expand our library and support the eye care community.</p>
  </div>

  <div className="faq-item">
    <h4>Do contributors earn rewards?</h4>
    <p>Yes! Contributors earn points for each approved submission. These points can be redeemed for exclusive benefits within our platform.</p>
  </div>

  <div className="faq-item">
    <h4>How do I redeem my earned points?</h4>
    <p>You can redeem your points through our rewards system, which allows you to access premium content or other special offers.</p>
  </div>

  <div className="faq-item">
    <h4>How can I contact the Eye Care Digital Library support team?</h4>
    <p>You can reach our support team via Telegram or by using the Contact Us form on our website.</p>
  </div>

  <div className="faq-item">
    <h4>Is the Eye Care Digital Library free to use?</h4>
    <p>Yes, accessing most resources is free. However, some premium content may require points or special access.</p>
  </div>

  <div className="faq-item">
    <h4>How do I search for specific resources?</h4>
    <p>You can use our general and advanced search functions to find resources by title, author, edition, publication year, or description.</p>
  </div>

  <div className="faq-item">
    <h4>How often are new resources added?</h4>
    <p>New resources are added regularly based on contributions from users and updates from our research team.</p>
  </div>
</section>


    </div>
  )
}

export default FAQs



